import { __extends } from "tslib";
import { MDCRipple } from '@material/ripple';
import { getShadowElement } from '@tyler-components-web/core';
import { BaseAdapter } from '../../core/adapters/base-adapter';
import { BUTTON_TOGGLE_CONSTANTS } from './button-toggle-constants';
var ButtonToggleAdapter = /** @class */ (function (_super) {
    __extends(ButtonToggleAdapter, _super);
    function ButtonToggleAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._buttonElement = getShadowElement(component, BUTTON_TOGGLE_CONSTANTS.selectors.BUTTON);
        return _this;
    }
    ButtonToggleAdapter.prototype.setSelected = function (value) {
        if (value) {
            this._buttonElement.classList.add(BUTTON_TOGGLE_CONSTANTS.classes.SELECTED);
        }
        else {
            this._buttonElement.classList.remove(BUTTON_TOGGLE_CONSTANTS.classes.SELECTED);
        }
        this._buttonElement.setAttribute('aria-pressed', value.toString());
    };
    ButtonToggleAdapter.prototype.addEventListener = function (type, listener) {
        this._buttonElement.addEventListener(type, listener);
    };
    ButtonToggleAdapter.prototype.removeEventListener = function (type, listener) {
        this._buttonElement.removeEventListener(type, listener);
    };
    ButtonToggleAdapter.prototype.initializeRipple = function () {
        return new MDCRipple(this._buttonElement);
    };
    ButtonToggleAdapter.prototype.setDisabled = function (value) {
        this._buttonElement.disabled = value;
        if (value) {
            this._buttonElement.setAttribute('aria-disabled', value.toString());
        }
        else {
            this._buttonElement.removeAttribute('aria-disabled');
        }
    };
    ButtonToggleAdapter.prototype.setDense = function (value) {
        if (value) {
            this._buttonElement.classList.add(BUTTON_TOGGLE_CONSTANTS.classes.DENSE);
        }
        else {
            this._buttonElement.classList.remove(BUTTON_TOGGLE_CONSTANTS.classes.DENSE);
        }
    };
    ButtonToggleAdapter.prototype.requestFocus = function () {
        this._buttonElement.focus();
    };
    ButtonToggleAdapter.prototype.detectStretchState = function () {
        if (this._component.hasAttribute(BUTTON_TOGGLE_CONSTANTS.attributes.STRETCH)) {
            return;
        }
        var buttonToggleGroup = this._component.parentElement;
        if (buttonToggleGroup && buttonToggleGroup.hasAttribute(BUTTON_TOGGLE_CONSTANTS.attributes.STRETCH) && buttonToggleGroup.stretch) {
            this._component.setAttribute(BUTTON_TOGGLE_CONSTANTS.attributes.STRETCH, '');
        }
    };
    return ButtonToggleAdapter;
}(BaseAdapter));
export { ButtonToggleAdapter };
